'use client';

import Image from "next/image";
import PageLayout from "@/components/PageLayout"
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import teamImage from "@/../public/karriere_teambildung.jpg";

import ArrowPathRoundedSquareIcon from "@/components/icons/arrow-path-rounded-square.svg";
import HeartSolidIcon from "@/components/icons/heart-solid.svg";
import { GET_HISTORY, GET_JOB_POSITIONS, GET_TEAM } from "@/lib/sanity/queries";
import { sanityClient } from "@/lib/sanity";
import { RetrievedHistoryItem, RetrievedJobPosition, RetrievedTeamMember } from "@/lib/sanity/responseTypes";
import Team from "./Team";
import History from "./History";
import JobPostings from "./JobPostings";
import { useLocale, useTranslations } from "next-intl";
import { useEffect, useState } from "react";

interface AboutUsPageProps {
  team: RetrievedTeamMember[];
  history: RetrievedHistoryItem[];
  jobs: RetrievedJobPosition[];
}

export default function AboutUsPage(props: AboutUsPageProps) {
  const locale = useLocale();
  const t = useTranslations("About");

  const [team, setTeam] = useState<RetrievedTeamMember[]>(props.team);
  const [history, setHistory] = useState<RetrievedHistoryItem[]>(props.history);
  const [jobs, setJobs] = useState<RetrievedJobPosition[]>(props.jobs);

  useEffect(() => {
    const teamQuery = GET_TEAM;

    sanityClient.fetch(teamQuery).then((res: RetrievedTeamMember[]) => {
      setTeam(res)
    });
  }, [])

  useEffect(() => {
    const historyQuery = GET_HISTORY;

    sanityClient.fetch(historyQuery).then((res: RetrievedHistoryItem[]) => {
      setHistory(res);
    });
  }, []);

  useEffect(() => {
    const jobsQuery = GET_JOB_POSITIONS;

    sanityClient.fetch(jobsQuery).then((res: RetrievedJobPosition[]) => {
      setJobs(res);
    });
  }, []);

  /*try {

  } catch (error) {
    console.error(`Error while retrieving team info: `, error);
    return <div className="error">⚠️ Failed to load team info. Try again later.</div>;
  }*/

  /*try {
    const historyQuery = GET_HISTORY;

    const historyInfo = (await sanityClient.fetch(historyQuery)) as RetrievedHistoryItem[];
    history = historyInfo;
  } catch (error) {
    console.error(`Error while retrieving history info: `, error);
    return <div className="error">⚠️ Failed to load company history. Try again later.</div>;
  }*/

  /*try {
    const jobsQuery = GET_JOB_POSITIONS;

    const jobsInfo = (await sanityClient.fetch(jobsQuery)) as RetrievedJobPosition[];
    jobs = jobsInfo;
  } catch (error) {
    console.error(`Error while retrieving open positions info: `, error);
    return <div className="error">⚠️ Failed to load job postings. Try again later.</div>;
    }*/

  return (
    <PageLayout>
      <div className="flex flex-col lg:flex-row w-full">
        <div className="flex flex-col flex-1 gap-2.5 px-5">
          <div className="flex flex-col leading-[120%] flex-auto">
            <div className="pt-5 md:pt-5 lg:pt-10 px-2.5 flex-1 text-center text-primary font-bold font-[Outfit] text-5xl md:text-[64px] flex flex-col">
              <div className="h-[64px] align-middle leading-[100%]">{t("title")}</div>
            </div>
            <div className="flex-auto pt-4 px-2.5 lg:px-5 xl:px-10 2xl:px-22.5 text-center text-primary font-[Outfit] lg:text-lg xl:text-xl 2xl:text-2xl flex flex-col justify-center">
              <div>
                {t("copy")}
              </div>
            </div>
          </div>
          <div className="flex-1 text-primary p-2.5 lg:px-10 pb-5">
            <div className="w-full overflow-hidden shrink-0 flex items-start justify-center gap-2.5 text-center flex-row">
              <div className="w-full flex flex-1 flex-col overflow-hidden shrink-0 p-2.5 gap-2.5 box-border text-center items-center">
                <div className="w-10 h-10 md:w-20 md:h-20 relative rounded-[5px] md:rounded-[10px] bg-white overflow-hidden shrink-0 text-center">
                  <div className="w-full h-5 md:h-10 bg-accent absolute top-5 md:top-10"></div>
                  <div className="text-primary absolute top-[5px] right-[5px] left-[5px] bottom-[5px] md:top-2.5 md:right-2.5 md:left-2.5 md:bottom-2.5 text-2xl md:text-6xl font-bold inline-block font-[Inter]">
                    1
                  </div>
                </div>
                <div className="self-stretch overflow-hidden flex flex-col items-start gap-2 text-xs lg:text-sm xl:text-base font-[Outfit]">
                  <div className="self-stretch relative leading-[120%] font-semibold">
                    {t('welcome_quality_title')}
                  </div>
                  <div className="self-stretch relative leading-[120%]">
                    {t('welcome_quality')}
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-1 flex-col overflow-hidden shrink-0 p-2.5 gap-2.5 box-border text-center items-center">
                <div className="w-10 h-10 md:w-20 md:h-20 relative rounded-[5px] md:rounded-[10px] bg-white overflow-hidden shrink-0 text-center">
                  <div className="w-full h-5 md:h-10 bg-accent absolute top-5 md:top-10"></div>
                  <ArrowPathRoundedSquareIcon className="w-[30px] h-[30px] md:w-[60px] md:h-[60px] absolute top-[5px] left-[5px] right-[5px] bottom-[5px] md:top-2.5 md:right-2.5 md:left-2.5 md:bottom-2.5 fill-primary" />
                </div>
                <div className="self-stretch overflow-hidden flex flex-col items-start gap-2 text-xs lg:text-sm xl:text-base font-[Outfit]">
                  <div className="self-stretch relative leading-[120%] font-semibold">
                    {t('welcome_reliability_title')}
                  </div>
                  <div className="self-stretch relative leading-[120%]">
                    {t('welcome_reliability')}
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-1 flex-col overflow-hidden shrink-0 p-2.5 gap-2.5 box-border text-center items-center">
                <div className="w-10 h-10 md:w-20 md:h-20 relative rounded-[5px] md:rounded-[10px] bg-white overflow-hidden shrink-0 text-center">
                  <div className="w-full h-5 md:h-10 bg-accent absolute top-5 md:top-10"></div>
                  <HeartSolidIcon className="w-[30px] h-[30px] md:w-[60px] md:h-[60px] absolute top-[5px] left-[5px] right-[5px] bottom-[5px] md:top-2.5 md:right-2.5 md:left-2.5 md:bottom-2.5 fill-primary" />
                </div>
                <div className="self-stretch overflow-hidden flex flex-col items-start gap-2 text-xs lg:text-sm xl:text-base font-[Outfit]">
                  <div className="self-stretch relative leading-[120%] font-semibold">
                    {t('welcome_passion_title')}
                  </div>
                  <div className="self-stretch relative leading-[120%]">
                    {t('welcome_passion')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col flex-1">
          <Image src={teamImage} alt={"Team"} className="w-full h-full object-center object-cover" />
        </div>
      </div>
      <div className="px-2.5 pb-2.5 md:px-[30px] md:pb-[30px] flex flex-col">
        <Team team={team} locale={locale} t={t} />
        <History history={history} />
        <JobPostings jobPostings={jobs} />
      </div>
    </PageLayout>
  )
}
